'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slider = require('./slider');

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _slider2['default']; // base react-slick 0.23.2